
import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface AboutMeHeaderProps {
  hasUnsavedChanges: boolean;
  onSave: () => void;
  isSaving?: boolean;
}

const AboutMeHeader: React.FC<AboutMeHeaderProps> = ({ 
  hasUnsavedChanges, 
  onSave,
  isSaving = false
}) => {
  return (
    <div className="mb-6">
      <div className="flex items-center justify-between">
        <h2 className="text-base font-medium">About Me</h2>
        <Button 
          onClick={onSave}
          className="flex items-center gap-2 hover:bg-black/90 disabled:hover:bg-black"
          disabled={!hasUnsavedChanges || isSaving}
        >
          {isSaving ? (
            <>
              <Loader2 className="h-4 w-4 animate-spin" />
              <span>Saving...</span>
            </>
          ) : (
            <span>Save Changes</span>
          )}
        </Button>
      </div>
      {isSaving && (
        <p className="text-center text-sm text-muted-foreground mt-2">
          Your profile is being updated. This may take a moment...
        </p>
      )}
    </div>
  );
};

export default AboutMeHeader;
